import { render } from "./Content.vue?vue&type=template&id=32b33f08&scoped=true"
import script from "./Content.vue?vue&type=script&lang=ts"
export * from "./Content.vue?vue&type=script&lang=ts"

import "./Content.vue?vue&type=style&index=0&id=32b33f08&lang=less&scoped=true"
import "./Content.vue?vue&type=style&index=1&id=32b33f08&lang=less"
script.render = render
script.__scopeId = "data-v-32b33f08"

export default script